<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-24" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header Card -->
      <div class="bg-gradient-to-r from-cyan-600 to-cyan-700 rounded-xl p-6 text-white">
        <div class="flex items-center gap-3">
          <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <div class="w-full">
            <h2 class="text-xl font-bold">جستجوی همه درخواست‌ها</h2>
            <p class="text-sm text-cyan-50">جستجو بر اساس شماره موبایل یا کد درخواست</p>
          </div>
        </div>
      </div>

      <!-- Search Section -->
      <div class="bg-white rounded-xl border border-gray-200 p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Mobile Search -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('search_phone') }}</label>
            <div class="relative">
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <input
                v-model="seach_input_mobile"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                :placeholder="$t('search_phone')"
                @keyup.enter="click_search()"
                class="w-full pr-4 pl-11 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
                style="border: 1px solid #d1d5db !important;"
              />
            </div>
          </div>

          <!-- Code Search -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">جستجو کد</label>
            <div class="relative">
              <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <input
                v-model="seach_input_code"
                type="text"
                placeholder="جستجو کد"
                @keyup.enter="click_search()"
                class="w-full pr-4 pl-11 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
                style="border: 1px solid #d1d5db !important;direction: ltr;"
              />
            </div>
          </div>
        </div>

        <!-- Search Button -->
        <button 
          @click="click_search()"
          class="w-full mt-4 bg-gradient-to-r from-cyan-600 to-cyan-700 hover:from-cyan-700 hover:to-cyan-800 text-white py-3 px-6 rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2"
        >
          جستجو
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </button>
      </div>

      <!-- Skeleton -->
      <div v-if="searchLoading" class="search-all-skeleton-group space-y-4" aria-hidden="true">
        <div
          v-for="n in skeletonCardCount"
          :key="'search-all-sk-' + n"
          class="skeleton-block skeleton-req-card"
        ></div>
      </div>

      <!-- Empty State -->
      <div v-else-if="hasSearched && request_items.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">نتیجه‌ای یافت نشد</p>
      </div>

      <!-- Request Cards -->
      <div v-else class="space-y-4">
        <div 
          v-for="(item, i) in request_items"
          :key="i"
          class="bg-white rounded-xl border border-gray-200 p-4 cursor-pointer hover:shadow-md hover:border-cyan-300 transition-all duration-200"
          @click="goToDetail(item)"
        >
          <!-- Request Header -->
          <div class="mb-2 pb-1 border-b border-gray-200">
            <div class="flex items-center gap-3 mb-2">
              <div class="w-10 h-10 rounded-full bg-cyan-100 flex items-center justify-center flex-shrink-0">
                <svg class="w-6 h-6 text-cyan-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div class="w-full">
                <h3 class="text-sm font-bold text-gray-900 truncate">{{ item.RequestName }}</h3>
                <p class="text-sm text-gray-500">{{ $t('requestNoQ') }}: <span class="font-bold text-gray-700">{{ item.RequestCode }}</span></p>
              </div>
            </div>
          </div>

          <!-- Request Details -->
          <div class="space-y-2 mb-4">
            <div class="flex items-center gap-2 text-sm text-gray-600">
              <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span>{{ $t('referDateQ') }}: <span class="font-medium text-gray-900">{{ item.ReferDate }}</span></span>
            </div>
            
            <div v-if="item.StateName" class="flex items-center gap-2 text-sm text-gray-600">
              <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>{{ item.StateName }}</span>
            </div>
            
            <div v-if="get_request_address(item) != ''" class="flex items-start gap-2 text-sm text-gray-600">
              <svg class="w-4 h-4 text-gray-400 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>{{ $t('addressQ') }}: {{ get_request_address(item) }}</span>
            </div>
          </div>

          <!-- Status Badge -->
          <div class="flex items-center">
            <div class="inline-block px-3 py-1 bg-cyan-100 text-cyan-700 text-xs font-medium rounded-full">
              {{ item.LastStatus }}
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Context Menu -->
    <vue-context ref="menu">
      <li>
        <a href="#" @click.prevent="">{{ $t('receiveSignature') }}</a>
      </li>
      <li>
        <a href="#" @click.prevent="context_menu_clicked('payments')">{{ $t('pays') }}</a>
      </li>
    </vue-context>

  </div>
</template>
<script>
  import Vue from 'vue'
  import moment from 'moment-jalaali'
  import { skeletonSilentRequest } from '../../utils/skeletonPages'

  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
  import VueContext from 'vue-context'
  import 'vue-context/src/sass/vue-context.scss'

  Vue.component('date-picker', VuePersianDatetimePicker)
  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        errors: [],

        seach_input_mobile: '',
        seach_input_code: '',
        request_items: [],
        clicked_request_context: null,
        searchLoading: false,
        hasSearched: false,
        skeletonCardCount: 5,
      }
    },
    components: {
      datePicker: VuePersianDatetimePicker,
      VueContext,
    },
    watch: {
      // 'start_date': function () {
      //
      // },
      // 'end_date': function () {
      //   this.get_report(0);
      //
      // },

    },
    mounted() {
      // This page doesn't use dates, only mobile and code search
    },
    methods: {
      click_search() {
        this.get_report(0)
      },
      open_context_menu(item) {
        var self = this
        var click_event = event
        this.clicked_request_context = item
        setTimeout(function () {
          self.$refs.menu.open(click_event, null)
        }, 150)
      },
      context_menu_clicked(func) {
        if (func == 'payments') {
          this.$router.push({path: '/report-request/add-price-result/' + this.clicked_request_context.RecId})
        }
      },
      get_request_address(item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' '
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' '
        }
        if (item.AddressText != null) {
          address += item.AddressText + ' '
        }
        return address
      },
      goToDetail(item) {
        console.log('req code is ', item.RequestCode, item)

        if (item.ModelId == 0) {
          this.$router.push({name: 'ViewRequestReadOnly', params: {rec_id: item.Id, rec_name: item.RequestCode}})
        } else {
          this.$router.push({name: 'ViewPreRequestReadOnly', params: {rec_id: item.Id}})
        }
      },
      get_report(page) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var mobile = this.seach_input_mobile;
        var code = this.seach_input_code;
        mobile = this.persian_to_english(mobile);
        code = this.persian_to_english(code);

        if (mobile.startsWith("0")) {
          mobile = mobile.substring(1, mobile.length);
        }
        if(mobile!=""){
          code = "";
        }
        const send_data = {
          UserId: user_id,
          SearchName: "",
          SearchMobile: mobile,
          SearchReq: code,
          Page: page,

        }

        if (page === 0) {
          self.searchLoading = true
          self.request_items = []
        }

        this.axios.post('/GetAllRequestsApp', send_data, skeletonSilentRequest)
          .then(response => {
            if (response.data.error == 0) {
              if (page == 0) {
                self.request_items = response.data.requests || []
              } else {
                response.data.refers.forEach(function (number) {
                  self.request_items.push(number)
                })
              }
              self.seach_input_mobile = "";
              self.seach_input_code="";
            } else {
              self.not_register = true
            }
          }).catch(e => {
          this.errors.push(e)
        }).finally(() => {
          if (page === 0) {
            self.searchLoading = false
            self.hasSearched = true
          }
        })
      },

    }
  }
</script>

<style>
  .search-all-skeleton-group {
    position: relative;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
  }

  .search-all-skeleton-group::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.55) 45%,
      rgba(255, 255, 255, 0.65) 55%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: search-all-skeleton-shimmer 1.4s ease-in-out infinite;
  }

  .search-all-skeleton-group .skeleton-block {
    background-color: #e5e7eb;
  }

  .search-all-skeleton-group .skeleton-req-card {
    min-height: 10.5rem;
    border-radius: 0.75rem;
  }

  @keyframes search-all-skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }
</style>
